import { TimelineMax, Power3 } from 'gsap';
import routeInitials from './initial';
import routesIn from './in';
import routesOut from './out';
import background from '@/scripts/background';

const sortElements = (elements, reverse = false) => {
  elements.sort((a, b) => {
    const aOrder = a.dataset.inOutOrder || 999;
    const bOrder = b.dataset.inOutOrder || 999;
    return reverse ? bOrder - aOrder : aOrder - bOrder;
  });
};

export const EnterRoute = (element) => {
  const view = element;
  const inElementsView = Array.from(view.querySelectorAll('[data-in-out]'));
  const inElementsSlider = Array.from(document.querySelectorAll('.slider[data-in-out]'));
  const sliderBackground = document.querySelector('.slider-background__white');
  const inElements = [...inElementsView, ...inElementsSlider];
  sortElements(inElements);

  const tl = new TimelineMax({ paused: true, delay: 0.8 });
  tl.addLabel('start');
  inElements.forEach(inElement => routeInitials.get(inElement.dataset.inOutAnimation)(inElement));
  if (element.dataset.name === 'home') {
    tl.to(sliderBackground, 0.6, { autoAlpha: 0, ease: Power3.easeOut }, 'start');
    document.querySelector('.slider').style.pointerEvents = 'auto';
    if (background.ref.loaded) background.ref.play();
  } else {
    document.querySelector('.slider').style.pointerEvents = 'none';
  }
  inElements.forEach((inElement, index) => {
    const delay = parseFloat(inElement.dataset.inDelay) || 0;
    tl.add(routesIn.get(inElement.dataset.inOutAnimation)(inElement), `start+=${(0.02 * index) + delay}`);
  });
  return tl;
};

export const LeaveRoute = (element) => {
  const view = element;
  const outElementsView = Array.from(view.querySelectorAll('[data-in-out]'));
  const outElementsSlider = Array.from(document.querySelectorAll('.slider[data-in-out]'));
  const sliderBackground = document.querySelector('.slider-background__white');
  const outElements = [...outElementsView, ...outElementsSlider];
  sortElements(outElements, true);

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start');
  tl.set(view, { zIndex: 3 });
  if (element.dataset.name === 'home') {
    tl.to(sliderBackground, 0.6, { autoAlpha: 1, ease: Power3.easeIn }, 'start');
    document.querySelector('.slider').style.pointerEvents = 'none';
    if (background.ref.loaded) background.ref.pause();
  } else {
    document.querySelector('.slider').style.pointerEvents = 'auto';
  }
  outElements.forEach((outElement, index) => {
    const delay = parseFloat(outElement.dataset.outDelay) || 0;
    tl.add(routesOut.get(outElement.dataset.inOutAnimation)(outElement), `start+=${(0.02 * index) + delay}`);
  });
  return tl;
};
